package com.milta.feature.imports.data.remote.dto

import com.milta.feature.imports.domain.entity.ExtractedDelivery
import com.milta.feature.imports.domain.entity.ImportPdfResult
import kotlinx.serialization.Serializable

/** Mirrors the backend `ImportPdfResultDto` returned by `POST /api/v1/imports/pdf` (MIL-26). */
@Serializable
data class ImportPdfResultDto(
    val totalExtracted: Int,
    val deliveries: List<ExtractedDeliveryDto>,
)

/** Mirrors the backend `ExtractedDeliveryDto` — one row read off the PDF, nothing persisted. */
@Serializable
data class ExtractedDeliveryDto(
    val tempId: String,
    val recipientName: String? = null,
    val address: String? = null,
    val phoneNumber: String? = null,
    val deadlineTime: String? = null,
    val missingFields: List<String> = emptyList(),
)

fun ImportPdfResultDto.toDomain() = ImportPdfResult(
    totalExtracted = totalExtracted,
    deliveries = deliveries.map { it.toDomain() },
)

fun ExtractedDeliveryDto.toDomain() = ExtractedDelivery(
    tempId = tempId,
    recipientName = recipientName,
    address = address,
    phoneNumber = phoneNumber,
    deadlineTime = deadlineTime,
    missingFields = missingFields,
)
